import script from "./Finance.vue?vue&type=script&setup=true&lang=js"
export * from "./Finance.vue?vue&type=script&setup=true&lang=js"

import "./Finance.vue?vue&type=style&index=0&id=de3a4f14&scoped=true&lang=css"

import exportComponent from "/builds/skilltech-ph/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de3a4f14"]])

export default __exports__